import { Component, type ErrorInfo, type ReactNode } from "react";
import { t } from "../i18n";

interface Props {
  children: ReactNode;
}

interface State {
  failed: boolean;
}

/**
 * A programming error in one screen must never leave the cashier with an empty page: the screen
 * shows what happened and can be reloaded, the rest of the till keeps working.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Screen failed", error, info.componentStack);
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="panel screen-error" role="alert">
        <h2>{t.errors.screenTitle}</h2>
        <p className="muted">{t.errors.screenHint}</p>
        <button type="button" className="btn primary" onClick={() => window.location.reload()}>
          {t.errors.reload}
        </button>
      </div>
    );
  }
}
